import { ws } from "../../../utils/common";

export const getDashboardAssociationWS = async ({ id_association }) => {
    const res = await ws(
        "GET",
        process.env.REACT_APP_ENDPOINT + "association/info/" + id_association,
        { dashboard: true },
        null,
        true
    );


    if (res.error) {
        throw res.data;
    } else {
        return res.data;
    }
}
